<template>
  <div class="members">
    <div class="Header">
      <myMembersHeader></myMembersHeader>
    </div>
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return {
      
    }
  }
}
</script>
<style lang="scss" scoped>
.Header {
  width: 100%;
  height: 13rem;
}

@media screen and (min-width: 1300px) and (max-width: 1567px) {
  .Header {
    width: 100%;
    height: 12.5rem;
  }
}
@media screen and (min-width: 1000px) and (max-width: 1313px) {
  .Header {
    width: 100%;
    height: 12.5rem;
  }
}
@media screen and (min-width: 984px) and (max-width: 1188px) {
  .Header {
    width: 100%;
    height: 13rem;
  }
}
@media screen and (min-width: 500px) and (max-width: 984px) {
  .Header {
    width: 100%;
    height: 13.6rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/home/members.vue